import { render, staticRenderFns } from "./materialModal.vue?vue&type=template&id=6f2df275&scoped=true&"
import script from "./materialModal.vue?vue&type=script&lang=js&"
export * from "./materialModal.vue?vue&type=script&lang=js&"
import style0 from "./materialModal.vue?vue&type=style&index=0&id=6f2df275&prod&lang=less&"
import style1 from "./materialModal.vue?vue&type=style&index=1&id=6f2df275&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2df275",
  null
  
)

export default component.exports